import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Central SEO component — set per-route <title>, meta description, canonical,
 * Open Graph, Twitter Card, and optional JSON-LD.
 *
 * Every public route MUST render this exactly once so Google, Facebook,
 * Messenger, WhatsApp and Twitter/X all pick up unique metadata.
 */

const SITE = {
  origin: "https://topofthelinetreeservicesllc.com",
  name: "Top of the Line Tree Services LLC",
  twitter: "", // add handle if the business creates one later
};

const DEFAULT_OG_IMAGE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_arborist-services-3/artifacts/ubt7y6bu_PHOTO-2026-07-22-21-06-36.jpg";

export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
  type = "website",
  jsonLd = null,
  noindex = false,
}) {
  const url = `${SITE.origin}${path}`;
  const fullTitle = title ? `${title} | ${SITE.name}` : SITE.name;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph — Facebook / Messenger / WhatsApp / LinkedIn */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {SITE.twitter && <meta name="twitter:site" content={SITE.twitter} />}

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export { SITE, DEFAULT_OG_IMAGE };
